// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import type { IButtonStyles, IStyle } from "@fluentui/react";
// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import { concatStyleSets, memoizeFunction } from "@fluentui/react";

import { ActionControlSize, controlStylingConstants } from "@1js/acui-common";

import type {
  AppFontPickerProps,
  AppFontPickerStyles,
} from "./AppFontPicker.Props";

const smallTextStyle: IStyle = {
  fontSize: 12,
  height: 16,
  lineHeight: 16,
};

export const smallFontPickerItemHeight = 28;

const smallCaretDownButtonStyles: IButtonStyles = {
  root: {
    height: controlStylingConstants.comboBoxSmallHeight,
    width: controlStylingConstants.comboBoxSmallCaretWidth,
    minWidth: controlStylingConstants.comboBoxSmallCaretWidth,
  },
  icon: {
    height: 8,
    width: 8,
    lineHeight: 8,
  },
};

const smallFontPickerStyles: AppFontPickerStyles = {
  root: {
    marginRight: controlStylingConstants.comboBoxSmallRightMargin,
    height: controlStylingConstants.comboBoxSmallHeight,
  },
  subComponentStyles: {
    dropDownStyles: {
      subComponentStyles: {
        itemStyles: {
          labelText: smallTextStyle,
        },
        headerStyles: {
          expand: {
            height: smallFontPickerItemHeight,
          },
          title: smallTextStyle,
        },
      },
    },
    textFieldStyles: {
      root: {
        height: controlStylingConstants.comboBoxSmallHeight,
      },
      textInput: smallTextStyle,
      subComponentStyles: {
        buttonStyles: smallCaretDownButtonStyles,
      },
    },
  },
};

const getSmallStylesInternal = memoizeFunction(
  (
    externalStyles?: AppFontPickerProps["styles"]
  ): Partial<AppFontPickerStyles> => {
    if (!externalStyles) {
      return smallFontPickerStyles;
    }

    return concatStyleSets(externalStyles, smallFontPickerStyles);
  }
);

export function getSizedFontPickerStyles(
  size: ActionControlSize,
  props: Partial<AppFontPickerProps>
): AppFontPickerProps["styles"] {
  if (size === ActionControlSize.Large) {
    return props.styles;
  }

  return getSmallStylesInternal(props.styles);
}
